import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import IDCardButton from './IDCardButton';

const GuarantorButton = () => {
  const [link, setLink] = useState('');
const  navigate = useNavigate();
  const generateLink = () => {
    const userId = localStorage.getItem('userId');
    if (!userId) {
      console.error('User ID not found in localStorage');
      return;
    }
    const guarantorLink = `https://ejobs.com.ng/guarantor/${userId}`;
    // const guarantorLink = `http://localhost:3000/guarantor/${userId}`;
    setLink(guarantorLink);
  };

  const guarantorView = () => {
    navigate(`/guarantor-view/${localStorage.getItem('userId')}`);
  }

  return (
    <div className="p-4 flex flex-col-2 gap-2 space-x-10">
      <button
        onClick={generateLink}
        className="bg-blue-500 text-white p-2 rounded hover:bg-blue-600"
      >
        Generate Guarantor Link
      </button>
      {link && (
        <p className="mt-2">
          <strong>Guarantor Link:</strong> <a href={link} target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline">{link}</a>
        </p>
      )}

      <button>
        <span onClick={guarantorView} className="bg-green-500 text-white p-2 rounded hover:bg-green-600 mt-4 inline-block">View Guarantor Details</span>
      </button>

      <IDCardButton/>
    </div>
  );
};

export default GuarantorButton;